import { invoke } from '@tauri-apps/api/core';

async function openUrl(payload) {
    return await invoke('plugin:oc|open_url', { payload }).then((r) => (r.value ? r.value : null));
}

// Authenticator attachment decoder(ish)!
// Note: we'd preferably use something like `zod` here, but may not worth a dependency
function decodeAuthenticatorAttachment(data) {
    if ("platform" === data["authenticatorAttachment"]) {
        return "platform";
    }
    if ("cross-platform" === data.authenticatorAttachment) {
        return "cross-platform";
    }
    throw new Error("Invalid authenticatorAttachment value");
}

// Convert base64 value to Uint8Array
function base64urlToUint8Array(base64url) {
    const base64 = base64url
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(base64url.length + (4 - base64url.length % 4) % 4, '=');
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
}

// SIGN IN!!
async function signIn(payload) {
    return invoke('plugin:oc|sign_in', { payload: payload ?? {} })
        .then(({ passkey }) => {
        const parsed = JSON.parse(passkey);
        const authenticatorAttachment = decodeAuthenticatorAttachment(parsed);
        const clientExtensionResults = parsed.clientExtensionResults ?? {};
        const id = parsed.id;
        const rawId = base64urlToUint8Array(parsed.rawId);
        const authenticatorData = base64urlToUint8Array(parsed.response.authenticatorData);
        const clientDataJSON = base64urlToUint8Array(parsed.response.clientDataJSON);
        const signature = base64urlToUint8Array(parsed.response.signature);
        const userHandle = base64urlToUint8Array(parsed.response.userHandle);
        return {
            authenticatorAttachment,
            clientExtensionResults,
            id,
            rawId,
            response: {
                kind: "signin",
                authenticatorData,
                clientDataJSON,
                signature,
                userHandle
            },
            type: "public-key",
        };
    });
}

// SIGN UP!!
async function signUp(payload) {
    return invoke("plugin:oc|sign_up", { payload }).then(({ passkey }) => {
        const parsed = JSON.parse(passkey);
        const authenticatorAttachment = decodeAuthenticatorAttachment(parsed);
        const clientExtensionResults = parsed.clientExtensionResults ?? {};
        const id = parsed.id;
        const rawId = base64urlToUint8Array(parsed.rawId);
        const attestationObject = base64urlToUint8Array(parsed.response.attestationObject);
        const authenticatorData = base64urlToUint8Array(parsed.response.authenticatorData);
        const clientDataJSON = base64urlToUint8Array(parsed.response.clientDataJSON);
        const publicKey = base64urlToUint8Array(parsed.response.publicKey);
        const publicKeyAlgorithm = parsed.response.publicKeyAlgorithm;
        const transports = parsed.response.transports ?? [];
        return {
            authenticatorAttachment,
            clientExtensionResults,
            id,
            rawId,
            response: {
                kind: "signup",
                attestationObject,
                authenticatorData,
                clientDataJSON,
                publicKey,
                publicKeyAlgorithm,
                transports,
            },
            type: "public-key",
        };
    });
}

async function getFcmToken() {
    return await invoke("plugin:oc|get_fcm_token").then((r) => r.fcmToken);
}

async function showNotification(payload) {
    return await invoke("plugin:oc|show_notification", { payload });
}

async function svelteReady() {
    return await invoke("plugin:oc|svelte_ready");
}

export { decodeAuthenticatorAttachment, getFcmToken, openUrl, showNotification, signIn, signUp, svelteReady };
